import { Box, Typography, IconButton, Card } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";

const ReportDefaultUi = ({ setOpen, text }) => {
  return (
    <Box p={3}>
      <Card
        sx={{
          p: 4,
          textAlign: "center",
          borderRadius: 3,
          boxShadow: 3,
        }}
      >
        <Typography variant="body1" fontWeight="600" sx={{ mb: 2 }}>
          Please apply filters to view your {text || "report"}
        </Typography>

        <IconButton
          color="primary"
          sx={{
            backgroundColor: "#E3F2FD",
            p: 2,
            borderRadius: "12px",
            "&:hover": { backgroundColor: "#BBDEFB" },
          }}
          onClick={() => {
            // open filter drawer/modal
            setOpen(true);
          }}
        >
          <FilterListIcon fontSize="large" />
        </IconButton>
      </Card>
    </Box>
  );
};

export default ReportDefaultUi;
